export default __webpack_public_path__ + "images/maps-marker.8d5dfaafe56876aa01136e915d03eb51.svg";